import axios from 'axios';

export interface ContractTypeDto {
  Oid: string;
  Name: string;
  Color: string;
  SortOrder: number;
  IsActive: boolean;
  PdfTemplateFileName: string | null;
  HasPdfTemplate: boolean;
  CreatedAt: string;
}

export interface ContractTypeFormData {
  Name: string;
  Color: string;
  SortOrder: number;
  IsActive: boolean;
}

const getHeaders = (token: string) => ({
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  },
});

export async function getContractTypes(token: string): Promise<ContractTypeDto[]> {
  const res = await axios.get('/api/ContractType', getHeaders(token));
  return res.data;
}

export async function createContractType(data: ContractTypeFormData, token: string): Promise<ContractTypeDto> {
  const res = await axios.post('/api/ContractType/Create', data, getHeaders(token));
  return res.data;
}

export async function updateContractType(oid: string, data: ContractTypeFormData, token: string): Promise<void> {
  await axios.put(`/api/ContractType/${oid}/Update`, data, getHeaders(token));
}

export async function deleteContractType(oid: string, token: string): Promise<void> {
  await axios.delete(`/api/ContractType/${oid}`, getHeaders(token));
}

export async function uploadTemplate(oid: string, file: File, token: string): Promise<{ FileName: string }> {
  const formData = new FormData();
  formData.append('file', file);
  const res = await axios.post(`/api/ContractType/${oid}/UploadTemplate`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data',
    },
  });
  return res.data;
}

export async function downloadTemplate(oid: string, token: string): Promise<Blob> {
  const res = await axios.get(`/api/ContractType/${oid}/DownloadTemplate`, {
    headers: { Authorization: `Bearer ${token}` },
    responseType: 'blob',
  });
  return res.data;
}

export async function deleteTemplate(oid: string, token: string): Promise<void> {
  await axios.delete(`/api/ContractType/${oid}/DeleteTemplate`, getHeaders(token));
}
